module.exports = __webpack_public_path__ + "img/Plastic006_1K_Roughness.4a16798e.jpg";